import { render, staticRenderFns } from "./DocumentSecret.vue?vue&type=template&id=4bbd689c&scoped=true"
import script from "./DocumentSecret.vue?vue&type=script&lang=js"
export * from "./DocumentSecret.vue?vue&type=script&lang=js"
import style0 from "./DocumentSecret.vue?vue&type=style&index=0&id=4bbd689c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbd689c",
  null
  
)

export default component.exports